import Enum from './enum'

class AssessmentUnit extends Enum
{
  constructor(value) {
    super(value);
  }
}

AssessmentUnit.init({
  EMPTY: 'None',
  CATALOG: 'Specification',
  LOT: 'Lot'
}, {
  EMPTY: 'assessment-unit.empty',
  CATALOG: 'assessment-unit.catalog',
  LOT: 'assessment-unit.lot'
});

export default AssessmentUnit;
